import React from 'react';

import PropTypes from 'prop-types';

import CountDisplay from 'components/projectsAnalytics/components/CountDisplay';
import StatusChart from 'components/projectsAnalytics/components/StatusChart';
import useKeyHighlight from 'components/projectsAnalytics/hooks/useKeyHighlight';

export default function StatusReportBody({
  chartData,
  onSegmentClick,
  totalCount,
}) {
  const { handleKeyHighlight, handleKeyUnhighlight, highlightedKey } =
    useKeyHighlight(null);

  const handleSegmentClick = ({ entry }) => {
    handleKeyUnhighlight();
    onSegmentClick({ entry });
  };

  return (
    <div className='tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-pb-10'>
      <div className='tw-flex tw-justify-center'>
        <div className='tw-flex tw-h-[180px] tw-w-[468px]'>
          <div className='tw-flex tw-w-full'>
            <div className='tw-h-[180px] tw-w-[180px]'>
              <StatusChart
                chartData={chartData}
                highlightedKey={highlightedKey}
                onKeyHighlight={handleKeyHighlight}
                onKeyUnhighlight={handleKeyUnhighlight}
                onSegmentClick={handleSegmentClick}
                totalCount={totalCount}
              />
            </div>
            <div
              className='tw-ml-6 tw-flex tw-h-[180px] tw-flex-1 tw-flex-col tw-justify-center'
              onMouseLeave={handleKeyUnhighlight}
            >
              {chartData.map((entry) => (
                <CountDisplay
                  count={entry.count}
                  countKey={entry.countKey}
                  dotClassName={entry.dotClassName}
                  highlightedKey={highlightedKey}
                  key={entry.countKey}
                  name={entry.name}
                  onClick={() => handleSegmentClick({ entry })}
                  onKeyHighlight={handleKeyHighlight}
                  onKeyUnhighlight={handleKeyUnhighlight}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

StatusReportBody.propTypes = {
  chartData: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
  onSegmentClick: PropTypes.func.isRequired,
};
